import React from 'react';

const Loading = () => {
  return (
    <div className="loading d-flex flex-column align-items-center justify-content-center" style={{ height: "80vh" }}>
      <div className="logo-container d-flex align-items-center justify-content-center" >
        <img src="/image/Loading.svg"   alt="Loading" />
        <img src="/image/ARJ.png" style={{ position: "absolute",width:'110px'}}  alt="Logo" className="logo" />
      </div>
        <h5>Fetching Data...</h5>
        
    </div>
  );
};

export default Loading;
